import { chatEE } from '@/layout/events/chat-event-emitter';
import { useCallback, useEffect, useState } from 'react';
import type { Message } from '../models/message';

export const useMessageForwardDialog = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState<Message | null>(null);

  useEffect(() => {
    const openHandler = (msg: Message) => {
      setMessage(msg);
      setShow(true);
    };

    chatEE.on('message-forward', openHandler);

    return () => {
      chatEE.off('message-forward', openHandler);
    };
  }, []);

  const handleClose = useCallback(async (handleReset?: () => void) => {
    setShow(false);
    setMessage(null);
    handleReset?.();
  }, []);

  return {
    show,
    setShow,
    message,
    handleClose
  };
};
